import _ from 'lodash'
import { callApi, getUrlWithPathParams } from 'services/api/utils'

import { UserGroup } from './types'

const USER_GROUPS_ENDPOINT_PATH = '/user-groups/'

export async function apiGetUserGroups(query: { ids?: number[] } = {}): Promise<ApiIdIndexedUserGroups> {
  const { ids } = query
  const userGroupsData = await callApi<ApiUserGroup[]>({
    url: USER_GROUPS_ENDPOINT_PATH,
    params: { ids },
  })
  return _.chain(userGroupsData).map(normalizeApiUserGroup).keyBy('id').value()
}

export async function apiGetUserGroup(id: number): Promise<ApiUserGroup> {
  const apiUserGroup = await callApi<ApiUserGroup>({
    url: getUrlWithPathParams(USER_GROUPS_ENDPOINT_PATH, id),
  })
  return normalizeApiUserGroup(apiUserGroup)
}

export async function adminApiGetUserGroup(id: number): Promise<ApiUserGroup> {
  const apiUserGroup = await callApi<ApiUserGroup>({
    url: getUrlWithPathParams(USER_GROUPS_ENDPOINT_PATH, id),
  })

  return normalizeApiUserGroup(apiUserGroup)
}

export async function apiPutUserGroup(userGroup: UserGroup): Promise<ApiUserGroup> {
  const apiUserGroup = await callApi<ApiUserGroup>({
    method: 'put',
    url: getUrlWithPathParams(USER_GROUPS_ENDPOINT_PATH, userGroup.id),
  })
  return normalizeApiUserGroup(apiUserGroup)
}

export async function apiPostUserGroup(userGroup: Partial<UserGroup>): Promise<ApiUserGroup> {
  const apiUserGroup = await callApi<ApiUserGroup>({
    method: 'post',
    url: USER_GROUPS_ENDPOINT_PATH,
    data: userGroup,
  })
  return normalizeApiUserGroup(apiUserGroup)
}

function normalizeApiUserGroup(userGroup: ApiUserGroup): ApiUserGroup {
  const normalizedUserGroup = _.clone(userGroup)
  return normalizedUserGroup
}

type ApiIdIndexedUserGroups = {
  [userGroupId: number]: ApiUserGroup
}

export type ApiUserGroup = {
  id: number
  name: string
  logoUrl?: string
  websiteUrl?: string
}
